var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0499 25.1036C27.0499 30.1312 23.0092 34.2069 18.0251 34.2069C13.041 34.2069 9 30.1303 9 25.1036C9 20.0769 13.0407 16 18.0251 16C23.0096 16 27.0499 20.076 27.0499 25.1036Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9509 25.1035C36.9509 29.836 34.9306 33.6739 32.4383 33.6739C29.9461 33.6739 27.9258 29.836 27.9258 25.1035C27.9258 20.3711 29.9458 16.5332 32.438 16.5332C34.9303 16.5332 36.9506 20.3699 36.9506 25.1035",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25.1037C41 29.3428 40.2896 32.7814 39.4129 32.7814C38.5363 32.7814 37.8262 29.3437 37.8262 25.1037C37.8262 20.8637 38.5366 17.426 39.4129 17.426C40.2893 17.426 41 20.8634 41 25.1037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.4c1adac8.svg";
export { ForwardRef as ReactComponent };